/** Tiny FR relative time + date helpers. */

export function timeAgoFr(iso) {
  if (!iso) return "—";
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return "—";
  const sec = Math.max(1, Math.floor((Date.now() - t) / 1000));
  if (sec < 60) return `il y a ${sec} s`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `il y a ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `il y a ${h} h`;
  const d = Math.floor(h / 24);
  if (d < 7) return `il y a ${d} j`;
  return new Date(iso).toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function formatDateTimeFr(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("fr-FR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatTimeFr(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleTimeString("fr-FR", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

export const LEVEL_META = {
  green: {
    label: "Feu vert",
    color: "#22C55E",
    bg: "#DCFCE7",
    ink: "#166534",
    ring: "#86EFAC",
  },
  orange: {
    label: "Feu orange",
    color: "#F59E0B",
    bg: "#FEF3C7",
    ink: "#92400E",
    ring: "#FCD34D",
  },
  red: {
    label: "Feu rouge",
    color: "#EF4444",
    bg: "#FEE2E2",
    ink: "#991B1B",
    ring: "#FCA5A5",
  },
};

export function truncate(str, n = 80) {
  if (!str) return "";
  return str.length > n ? `${str.slice(0, n - 1)}…` : str;
}
